
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SLAuthorization } from './authorization';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const AccountsQuery = require('./gql/authorizations.query.gql');

const createSLAuthorizationMutation = require('./gql/create-authorization.mutation.gql');
const deleteSLAuthorizationMutation = require('./gql/delete-authorization.mutation.gql');

export class SLAuthorizationFilter {
  account: string
  entity: string
}


@Injectable()
export class SLAuthorizationService {

  constructor(private apollo: Apollo) { }

  authorizations(filter: SLAuthorizationFilter): Observable<SLAuthorization[]> {
    return this.apollo
      .query({
        query: AccountsQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        return _map(result.data['slAuthorizations'], item => new SLAuthorization(item));
      }));
  }

  create(authorization: SLAuthorization): Observable<SLAuthorization> {
    return this.apollo
      .mutate({
        mutation: createSLAuthorizationMutation,
        variables: {
          input: authorization.toCreateSLAuthorizationInput()
        }
      }).pipe(
      map(result => new SLAuthorization(result.data['createSLAuthorization'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteSLAuthorizationMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteSLAuthorization']));
  }
}
